import { Component, OnInit } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { environment } from '../../environments/environment';
import { GlobalModalService } from '../shared/global-modal/global-modal.service';
import { TenantService } from '../services/tenant.service';

@Component({
  selector: 'app-system-config',
  templateUrl: './system-config.component.html',
  styleUrls: ['./system-config.component.scss']
})
export class SystemConfigComponent implements OnInit {
  apiUrl = environment.api_service_users.replace('/users', '/config');
  
  allConfigs: any[] = [];
  filteredConfigs: any[] = [];
  tenants: any[] = [];
  
  selectedTenantFilter: string = ''; // '' = MODO GLOBAL
  
  configForm: FormGroup;
  isEditing: boolean = false;
  editingId: string | null = null;
  loading: boolean = true;

  // Mapa para controlar qué campos secretos se están revelando
  revealMap: { [key: string]: boolean } = {};

  constructor(
    private http: HttpClient,
    private fb: FormBuilder,
    private modalService: GlobalModalService,
    private tenantService: TenantService
  ) {
    this.configForm = this.fb.group({
      key: ['', Validators.required],
      value: ['', Validators.required],
      is_public: [false],
      is_secret: [false]
    });
  }

  ngOnInit(): void {
    this.loadTenants();
    this.loadConfigs();
  }

  loadTenants() {
    this.tenantService.getAllTenants().subscribe(data => this.tenants = data);
  }

  loadConfigs() {
    this.loading = true;
    this.http.get<any[]>(this.apiUrl).subscribe(data => {
      this.allConfigs = data;
      this.applyFilter();
      this.loading = false;
    });
  }

  applyFilter() {
    this.revealMap = {}; // Reset visualización
    if (!this.selectedTenantFilter || this.selectedTenantFilter === '') {
      // Modo Global: Filtramos estrictamente los que NO tienen tenantid
      this.filteredConfigs = this.allConfigs.filter(c => !c.tenantid);
    } else {
      // Modo Cliente: Filtramos estrictamente por el ID del Tenant seleccionado
      this.filteredConfigs = this.allConfigs.filter(c => c.tenantid === this.selectedTenantFilter);
    }
  }

  // MODIFICADO: Ahora es invocado por ngModelChange, sin necesidad de event.target
  onFilterChange() {
    this.applyFilter();
    this.resetForm();
  }

  toggleReveal(id: string) {
    this.revealMap[id] = !this.revealMap[id];
  }

  editConfig(config: any) {
    this.isEditing = true;
    this.editingId = config.id;
    this.configForm.patchValue({
      key: config.key,
      value: config.value,
      is_public: config.is_public,
      is_secret: config.is_secret
    });
  }

  deleteConfig(id: string) {
    if (confirm('¿Seguro que deseas eliminar esta variable?')) {
      this.http.delete(`${this.apiUrl}/${id}`).subscribe(() => {
        this.loadConfigs();
        this.modalService.showSuccess("Eliminado", "Variable eliminada correctamente.");
      });
    }
  }

  resetForm() {
    this.isEditing = false;
    this.editingId = null;
    this.configForm.reset({ is_public: false, is_secret: false });
  }

  saveConfig() {
    if (this.configForm.invalid) return;

    const payload = {
      ...this.configForm.value,
      id: this.editingId,
      tenantid: this.selectedTenantFilter === '' ? null : this.selectedTenantFilter
    };

    this.http.post(this.apiUrl, payload).subscribe({
      next: () => {
        this.loadConfigs();
        this.resetForm();
        this.modalService.showSuccess("Guardado", "Configuración actualizada en BBDD.");
      },
      error: () => this.modalService.showError("Error", "Error al guardar (Posible clave duplicada).")
    });
  }
}